/**
 * Format a Rand amount as R830k or R4.3m for compact display.
 * @param {number} amount 
 * @returns {string}
 */
export function formatCostShort(amount) {
  if (!amount || amount <= 0) return '—';
  const num = Number(amount);
  if (num >= 1000000) {
    const m = num / 1000000;
    const rounded = Math.round(m * 10) / 10;
    return `R${rounded.toString().replace('.', ',')}m`;
  }
  if (num >= 1000) {
    return `R${Math.round(num / 1000)}k`;
  }
  return `R${num.toFixed(0)}`;
}

/**
 * Format a Rand amount as R1,234.56
 */
export function formatCost(amount) {
  if (!amount && amount !== 0) return 'R0.00';
  return `R${Number(amount).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
